import type { UpdaterState } from '@teachpartner/contracts';
import { Time } from '../../components/time';
import { Unknown } from '../../components/version';

/** What central runs now, what the updater last found, and how it is set up. */
export function UpdateSummary({ state }: { state: UpdaterState }) {
  return (
    <section aria-label="Release on central">
      <h2>Release on central</h2>
      <dl className="facts">
        <dt>Current</dt>
        <dd>{state.current ?? <Unknown label="Not deployed yet" />}</dd>
        <dt>Previous</dt>
        <dd>{state.previous ?? <Unknown label="None" />}</dd>
        <dt>Latest checked release</dt>
        <dd>
          {state.latest ? (
            <>
              {state.latest.version} <span className="muted">(checked </span>
              <Time iso={state.latest.checkedAt} />
              <span className="muted">)</span>
            </>
          ) : (
            'None found yet'
          )}
        </dd>
        <dt>Automatic deploy</dt>
        <dd>
          {state.autoDeploy ? 'On' : 'Off'}{' '}
          <span className="muted">(set on central with TP_UPDATER_AUTO_DEPLOY)</span>
        </dd>
        <dt>Last poll</dt>
        <dd>
          <Time iso={state.lastPollAt} missing="Not polled yet" />
        </dd>
      </dl>
    </section>
  );
}
